module.exports = __webpack_public_path__ + "static/media/logo_coming_soon.c67a17a2.svg";